const DoNotPrefix = /^do\s*not\s+/i;

/**
 * A "do not" display name as the permission it grants - "Do Not Bulk Email" becomes
 * "Bulk Email".
 *
 * Only for an attribute the API says it reverses (`ValueReversed` on the metadata): the
 * value arriving already means the permission, so the metadata's own name says the
 * opposite of what the control does. The name alone is never enough to decide this -
 * `donotsendmm` and every `g4_donot..._combined` flag read exactly as stored.
 *
 * A default, not a rule. The author renames the field to whatever the club calls it.
 */
export function positiveLabel(label: string): string {
  if (!DoNotPrefix.test(label ?? "")) {
    return label;
  }

  const stripped = label.replace(DoNotPrefix, "").trim();

  return stripped ? stripped.charAt(0).toUpperCase() + stripped.slice(1) : label;
}
